import { styled } from '@mui/material';

import { Typography } from '../../../Typography';

export type TitleProps = {
  title: string;
};

const StyledTitle = styled(Typography)({
  fontSize: 18,
  fontWeight: 500,
});

export const Title = ({ title }: TitleProps) => {
  return <StyledTitle component="h2">{title}</StyledTitle>;
};
